<template>
  <div v-if="hasRequirements || links.length > 0" class="library">
    <SidebarTitle v-if="title" :title="title" />
    <div class="library__list">
      <div v-for="(item, index) in links" :key="index" class="library__item">
        <Info
          v-if="item.update_date"
          :text="'UPDATED ' + item.update_date"
          :arrow="true"
        />
        <Button :text="item.title" :link="resolveLink(item)" />
      </div>
      <Button
        v-if="hasRequirements"
        :text="jurisdictionName + `   Requirements`"
        :link="`/requirement?id=${jurisdictionId}&cid=${jurisdictionChildId}`"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Library",
  components: {
    SidebarTitle: () => import("./SidebarTitle"),
    Button: () => import("../../components/elements/Button"),
    Info: () => import("../../components/elements/Info"),
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    links: {
      type: [Array, Object],
      default: null,
    },
    jurisdictionName: {
      type: String,
      default: null,
    },
    jurisdictionId: {
      type: [Number, String],
      default: null,
    },
    jurisdictionChildId: {
      type: [Number, String],
      default: null,
    },
    hasRequirements: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    resolveLink(item) {
      if (item.url) {
        return item.url;
      }
      if (item.uri) {
        return item.uri;
      }
      if (item.view_node) {
        return item.view_node;
      }
      return "";
    },
  },
};
</script>

<style scoped lang="scss">
.library {
  margin-bottom: 2.8rem;

  &__list {
    padding-right: 1.6rem;
  }

  &__item {
    margin-bottom: 0.8rem;

    &:last-of-type {
      margin-bottom: 0;
    }

    .info {
      margin-bottom: 1rem;
    }
  }

  .button {
    width: 100%;
  }
}
</style>
